import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import { ProfileRequest } from './requests/profile.request';
import { ModuleWithScreens, ProfileResponse } from './responses/profile.response';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';

export class ProfileService extends BaseService {
    protected get resourceName(): string {
        return 'crm/profiles';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<ProfileResponse>>> {
        return await this.get<PagedResponse<ProfileResponse>>('paginated' + (filter ?? ''), params);
    }

    /// Só os ativos. É o que alimenta a escolha no cadastro de usuário.
    public async getActive(): Promise<AxiosResponse<{ data: ProfileResponse[] }>> {
        return await this.get('');
    }

    /// As telas existentes saem do enum do servidor, para não oferecer permissão que o back recusa.
    public async getScreens(): Promise<AxiosResponse<{ data: ModuleWithScreens[] }>> {
        return await this.get('screens');
    }

    /// As ações também saem do enum do servidor.
    public async getActions(): Promise<AxiosResponse<{ data: string[] }>> {
        return await this.get('actions');
    }

    public async create(body: ProfileRequest): Promise<AxiosResponse<{ data: ProfileResponse }>> {
        return await this.post(body);
    }

    public async update(
        id: string,
        body: ProfileRequest
    ): Promise<AxiosResponse<{ data: ProfileResponse }>> {
        return await this.put(id, body);
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
